import React from 'react';
import { ComparisonRow } from '../data/comparisons';
interface ComparisonTableProps {
  rows: ComparisonRow[];
  beforeLabel: string;
  afterLabel: string;
  tone?: 'light' | 'dark';
  caption?: string;
}
export function ComparisonTable({
  rows,
  beforeLabel,
  afterLabel,
  tone = 'light',
  caption
}: ComparisonTableProps) {
  const border = tone === 'dark' ? 'border-warm-lineDark' : 'border-warm-line';
  const head = tone === 'dark' ? 'text-creme/60' : 'text-warm';
  const before = tone === 'dark' ? 'text-creme/60' : 'text-warm';
  const after = tone === 'dark' ? 'text-creme' : 'text-graphite';
  return <table className="w-full border-collapse text-left" data-id="element-57" data-mp="38czsye66hmli">
      {caption && <caption className="sr-only" data-id="element-58" data-mp="3dcvwkcayrc0j">{caption}</caption>}
      <thead data-id="element-59" data-mp="3dbkwamgq8me6">
        <tr className={`border-b ${border}`} data-id="element-60" data-mp="3df8mpcqvksoo">
          <th scope="col" className={`w-1/2 pb-4 pr-6 text-xs font-semibold uppercase tracking-[0.14em] ${head}`} data-id="element-61" data-mp="1wymjiec699p0">
            {beforeLabel}
          </th>
          <th scope="col" className={`w-1/2 pb-4 pl-6 text-xs font-semibold uppercase tracking-[0.14em] ${head}`} data-id="element-62" data-mp="2dwvvrvx7xlte">
            {afterLabel}
          </th>
        </tr>
      </thead>
      <tbody data-id="element-63" data-mp="2nwmpvwhv9ysy">
        {rows.map(row => <tr key={row.before} className={`border-b ${border} align-top`} data-id="element-64" data-mp="2ntihemxdcgwh">
            <td className={`py-5 pr-6 text-sm leading-relaxed ${before} md:text-base`} data-id="element-65" data-mp="2iuxeugun9l4v">
              {row.before}
            </td>
            <td className={`py-5 pl-6 text-sm font-medium leading-relaxed ${after} md:text-base`} data-id="element-66" data-mp="2sv7tm5wbv0m5">
              {row.after}
            </td>
          </tr>)}
      </tbody>
    </table>;
}